import * as firebase from 'firebase/app';
import 'firebase/firestore';

export const checkUniqueness = (value, collection, field) => {
  var unique = firebase.functions().httpsCallable('dbHelpersCheckUniqueness');
  return unique({
    value: value,
    collection: collection,
    field: field
  })
    .then(result => {
      return result.data;
    })
    .catch(error => {
      throw new Error(error);
    });
};
